var AgeRestrictedView = (function (BaseView, GetPageTemplate) {

    function AgeRestrictedView (model) {
        var pt = window.GetPageTemplate || window.kos && window.kos.getPageTemplate || window.PageTemplates && window.PageTemplates.get;

        function init(isAgeRestricted) {
            if (isAgeRestricted) {
                $(function () {
                    _.each($('@ageRestricted'), function (el) {
                        var ageRestricter = new Switch({
                            selectedClass: 'switch-option__selected',
                            testClass: 'test-age-restricted',
                            defaultValue: null,
                            trueText: pt('js_Yes'),
                            falseText: pt('js_No'),
                            label: GetPageTemplate('_AgeRestrictedText'),
                            labelPosition: 'right', // 'left'
                            onChanged: function (value) {
                                model.set('IsAgreeWithAgeRestricted', !!value);
                            }
                        });
                        ageRestricter.appendTo($(el));

                        model.on('change:IsAgreeWithAgeRestricted', function (model) {
                            ageRestricter.setValue(model.get('IsAgreeWithAgeRestricted'));
                        });
                    });
                });
            }

            $('@ageRestricted').toggleClass('hidden-block', !isAgeRestricted);
        }

        model.on('change:IsAgeRestricted', function (model) {
            var isAgeRestricted = model.get('IsAgeRestricted');
            init(isAgeRestricted);
            if (isAgeRestricted && window.app && app.event && app.event.ageRestrictedDisplay) {
                app.event.ageRestrictedDisplay();
            }
        });

        init(model.get('IsAgeRestricted'));

    };

	return AgeRestrictedView;
})(BaseView, kos.getPageTemplate);


var AgeRestrictedDateView = (function (model) {

    $(function () {

        var settings = CheckoutSettings.getBasketSettings();
        var mode = settings.AgeRestrictedMode || 1;
        var list = [];
        var currentDate;

        _.each($('@ageRestricted'), function (el) {
            var dateSelector = app.DateSelector($(el));

            model.on('change:IsAgeRestricted', function (model) {
                var isAgeRestricted = model.get('IsAgeRestricted');
                dateSelector.init(isAgeRestricted);
                $('@ageRestricted').toggleClass('hidden-block', !isAgeRestricted);
                
                if (isAgeRestricted && window.app && app.event && app.event.ageRestrictedDisplay) {
                    app.event.ageRestrictedDisplay();
                }
            });

            var isAgeRestricted = model.get('IsAgeRestricted');

            dateSelector.init(isAgeRestricted);

            list.push(dateSelector);

            $('@ageRestricted').toggleClass('hidden-block', !isAgeRestricted);

        });

        _.each(list, function (ds, index) {
            ds.onChange(function (isValid, date, selectedDate) {
                if (isValid !== undefined && date && date.getTime() !== currentDate) {
                    currentDate = date.getTime();
                    api.saveAgeRestrictedConsentData(date.format());
                }
                model.set('IsAgreeWithAgeRestricted', !!isValid);
                _.each(list, function (_ds, i) {
                    if (i !== index) _ds.setDate(selectedDate);
                });
            });
        });



    });

});